import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../providers/auth.service';


export class RootComponent {
	public clientHomeRoute: string = process.env.CLIENT_APP_URL;

	constructor(
		private authService: AuthService,
		private router: Router) {
			if (this.authService.userType === 'client') {
				window.location.assign(this.clientHomeRoute);
				return;
			}
			this.router.navigate(['/not-found']);
	}
static ctorParameters() { return [ { type: AuthService }, { type: Router } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/error/root.component.ts